import { useNavigate } from 'react-router-dom';
import { AuthResetPasswordPage } from '@euroasiann/shared/ui';
import { apiFetchUrl } from '../lib/api';
import mapBackground from '../assets/map_background.png';

export default function ResetPassword() {
  const navigate = useNavigate();

  return (
    <AuthResetPasswordPage
      portalName="Tech Portal"
      backgroundSrc={mapBackground}
      backgroundAlt="Platform operations map"
      apiFetchUrl={apiFetchUrl}
      onNavigateLogin={() => navigate('/login')}
    />
  );
}
